'use client';

import { Button, Card } from '@/components/core';
import { Trans } from '@lingui/react/macro';
import { Image } from '@/components/core/components/atoms';
import { useDownloadApp } from '@/components/core/components/organism/download-app-modal/download-app-modal';
import * as styles from './recommendation-card.styles';

const RecommendationCard = () => {
  const openDownloadApp = useDownloadApp();
  return (
    <Card className={styles.root}>
      <div className={styles.content}>
        <h2 className={styles.title}>
          <Trans>Do you have something to recommend?</Trans>
        </h2>
        <p>
          <Trans>What movie made you laugh non-stop? What book left you with an existential void when you finished it?</Trans>
        </p>
        <p>
          <Trans>Recommend everything that has left you with a good taste and let everyone discover your great taste!</Trans>
        </p>
        <Button
          onClick={() => {
            return openDownloadApp('default');
          }}
          className={styles.seeMore}
        >
          <Trans>See more</Trans>
        </Button>
      </div>
      <div className={styles.video}>
        <video autoPlay muted loop src="/video/home.mp4" playsInline />
      </div>
      <div className={styles.download}>
        <div className={styles.qr}>
          <Image src="/download-app.svg" alt="qr code" />
        </div>
        <div className={styles.downloadContent}>
          <div className={styles.downloadTitle}>
            <Trans>Download the Peoople app</Trans>
          </div>
          <div className={styles.downloadStore}>
            <a href="https://apps.apple.com/es/app/peoople/id1121257820" target="_blank" rel="nofollow noopener">
              <Image src="/download-ios.svg" width={150} alt="ios download" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.peopleitrust.pitapp" target="_blank" rel="nofollow noopener">
              <Image src="/download-android.png" width={150} alt="android download" />
            </a>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default RecommendationCard;
